import * as parcelBarcodeLength from '../constants/parcelBarcodeLength';

export const getParcelNumber = (labelNumber = '') => {
  switch (labelNumber && labelNumber.length) {
    case parcelBarcodeLength.CODE_128: {
      if (labelNumber[0] !== '%') {
        return labelNumber.slice(7, 21);
      }
      return labelNumber.slice(8, 22);
    }
    case parcelBarcodeLength.CODE_39: {
      return labelNumber.slice(9, 19);
    }
    default:
      return labelNumber;
  }
};

export default getParcelNumber;
